import script from "./mobile-header.vue?vue&type=script&setup=true&lang=ts"
export * from "./mobile-header.vue?vue&type=script&setup=true&lang=ts"

import "./mobile-header.vue?vue&type=style&index=0&id=1ed973fe&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ed973fe"]])

export default __exports__